<template>
  <div>
    <svg
      class="clickable"
      style="max-height:200px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="260.8px"
      height="600px"
      viewBox="241.867 0 260.8 600"
      enable-background="new 241.867 0 260.8 600"
      xml:space="preserve"
    >
      <g id="SADOW_H-LIGHT_1_">
        <linearGradient
          id="SVGIDC_1_"
          gradientUnits="userSpaceOnUse"
          x1="-378.5845"
          y1="1134.7512"
          x2="-378.5845"
          y2="1098.8508"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0" style="stop-color:#B3B3B3" />
          <stop offset="0.0566" style="stop-color:#B7B7B7" />
          <stop offset="0.6897" style="stop-color:#EBEBEB" />
          <stop offset="1" style="stop-color:#FFFFFF" />
        </linearGradient>
        <path
          id="bumper"
          :style="bumperClass"
          v-on:click="changeSeverity('bumper')"
          d="M337.867,11.734c-23.733,0.533-47.2,3.199-65.867,8c-17.6,4.533-29.867,20.533-29.867,38.666
		v485.333c0,18.134,12.267,34.134,29.867,38.667c18.667,4.8,42.133,7.733,65.867,8.267V11.734z"
        />
        <path
          id="boot"
          :style="bootClass"
          v-on:click="changeSeverity('boot')"
          d="M337.867,11.734c40.857,0.533,81.254,3.199,113.385,8c30.297,4.533,51.415,20.533,51.415,38.666v485.333
		c0,18.134-21.118,34.134-51.415,38.667c-32.131,4.8-72.528,7.733-113.385,8.267V11.734z"
        />

        <linearGradient
          id="SVGIDC_2_"
          gradientUnits="userSpaceOnUse"
          x1="-378.5845"
          y1="1077.0217"
          x2="-378.5845"
          y2="1074.1721"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0" style="stop-color:#FFFFFF" />
          <stop offset="1" style="stop-color:#B3B3B3" />
        </linearGradient>
        <path
          fill="url(#SVGIDC_2_)"
          d="M396,26.666v549.066C406.133,575.733,406.133,26.666,396,26.666z"
        />

        <linearGradient
          id="SVGIDC_3_"
          gradientUnits="userSpaceOnUse"
          x1="-377.9849"
          y1="1074.176"
          x2="-377.9849"
          y2="1051.6337"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0" style="stop-color:#FFFFFF" />
          <stop offset="1" style="stop-color:#CCCCCC" />
        </linearGradient>
        <path
          fill="url(#SVGIDC_3_)"
          d="M450.934,416.267l-47.2-16v-0.534l38.934,5.067c5.6,0.8,10.399-3.733,10.399-9.334V210.133
		c0-5.6-4.8-9.866-10.399-9.333l-38.934,5.066v-0.533l47.2-16c6.399-2.133,12.8,2.667,12.8,9.333v208.267
		C463.733,413.6,457.333,418.4,450.934,416.267z"
        />
        <path
          fill="#F2F2F2"
          d="M442.667,404.8l-38.934-5.067V205.866l38.934-5.066c5.6-0.8,10.399,3.733,10.399,9.333v185.6
		C453.333,401.333,448.267,405.6,442.667,404.8z"
        />

        <linearGradient
          id="SVGIDC_4_"
          gradientUnits="userSpaceOnUse"
          x1="-321.0601"
          y1="1058.9592"
          x2="-273.6353"
          y2="1058.9592"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0" style="stop-color:#000000" />
          <stop offset="1" style="stop-color:#999999" />
        </linearGradient>
        <path
          fill="url(#SVGIDC_4_)"
          d="M436,463.466v117.601c1.866-1.066,3.733-2.134,5.333-3.2V463.199c0-8,4.223-7.291,11.155-6.224l0,0
		C442.889,452.976,436,453.333,436,463.466z"
        />

        <linearGradient
          id="SVGIDC_5_"
          gradientUnits="userSpaceOnUse"
          x1="-483.6348"
          y1="1058.8274"
          x2="-434.8726"
          y2="1058.8274"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0" style="stop-color:#999999" />
          <stop offset="1" style="stop-color:#000000" />
        </linearGradient>
        <path
          fill="url(#SVGIDC_5_)"
          d="M436,138.666v-117.6c1.866,1.066,3.733,2.134,5.333,3.2v114.666c0,8,4.929,11.802,11.861,10.734l0,0
		C443.595,153.667,436,149.067,436,138.666z"
        />

        <linearGradient
          id="SVGIDC_6_"
          gradientUnits="userSpaceOnUse"
          x1="-378.5347"
          y1="1090.0198"
          x2="-378.5347"
          y2="1079.1368"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0" style="stop-color:#000000" />
          <stop offset="0.1464" style="stop-color:#999999" />
          <stop offset="0.7699" style="stop-color:#999999" />
          <stop offset="1" style="stop-color:#000000" />
        </linearGradient>
        <path
          fill="url(#SVGIDC_6_)"
          d="M390.4,537.067c0-10.934-2.667-21.601-7.733-31.467L376,493.067
		c-3.467-6.4-5.333-13.867-5.333-21.066V137.866c0-7.467,1.867-14.666,5.333-21.066l6.667-12.533
		c5.067-9.601,7.733-20.533,7.733-31.467V10.4l-8,67.2c-1.066,5.867-2.933,11.733-5.6,17.066l-7.466,14.4
		c-5.067,9.6-7.733,20.267-7.733,31.2v160v169.6c0,10.934,2.667,21.6,7.733,31.2l7.466,14.399c2.934,5.334,4.8,11.2,5.6,17.067
		l8,59.733V537.067z"
        />

        <linearGradient
          id="SVGIDC_7_"
          gradientUnits="userSpaceOnUse"
          x1="-378.6343"
          y1="1116.1516"
          x2="-378.6343"
          y2="1097.2063"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0.2218" style="stop-color:#000000" />
          <stop offset="0.8912" style="stop-color:#999999" />
          <stop offset="1" style="stop-color:#000000" />
        </linearGradient>
        <path
          fill="url(#SVGIDC_7_)"
          d="M327.467,512.8c9.333-8.267,14.667-20,14.667-32.533V122.133c0-12.533-5.333-24.267-14.667-32.533
		l-35.733-31.467L313.067,88c6.667,9.333,10.133,20.533,10.133,32v362.133c0,11.467-3.467,22.667-10.133,32L291.733,544
		L327.467,512.8z"
        />
      </g>
      <g>
        <g>
          <path
            fill="#676767"
            d="M242.133,509.333v-418.4C252.8,91.2,256.8,91.467,264,92.533s12.267,7.2,12.267,14.133
			c2.133,144.801,2.133,228,0,386.667c0,7.2-5.333,13.066-12.267,14.133C256.8,508.8,252.8,509.067,242.133,509.333z"
          />
          <path
            fill="#696969"
            d="M242.133,508.8V91.467c10.667,0.267,14.4,0.533,21.6,1.6C270.667,94.133,276,100,276,107.2
			c1.867,144.533,2.133,227.466,0,385.6c0,7.2-5.333,13.066-12.267,14.133C256.533,508.267,252.8,508.533,242.133,508.8z"
          />
          <path
            fill="#6A6A6A"
            d="M242.133,508.533V92c10.667,0.267,14.4,0.533,21.6,1.6c6.933,1.066,12.267,6.934,12.267,14.134
			c1.867,144.267,2.133,226.933,0,384.8c0,7.199-5.333,13.066-12.267,14.133C256.533,507.733,252.8,508,242.133,508.533z"
          />
          <path
            fill="#6C6C6C"
            d="M242.133,508V92.533c10.667,0.267,14.4,0.533,21.333,1.6c6.933,1.067,12.267,6.934,12.267,14.134
			c1.867,144,2.133,226.399,0,383.733c0,7.199-5.333,13.066-12.267,14.133C256.267,507.466,252.533,507.466,242.133,508z"
          />
          <path
            fill="#6D6D6D"
            d="M242.133,507.466V93.067c10.667,0.267,14.133,0.533,21.333,1.6c6.933,1.067,12,6.934,12.267,14.134
			c1.867,143.467,2.133,225.866,0,382.933c0,7.2-5.333,13.067-12.267,14.134C256.267,506.933,252.533,507.199,242.133,507.466z"
          />
          <path
            fill="#6F6F6F"
            d="M242.133,506.933V93.6c10.4,0.267,14.133,0.533,21.067,1.601c6.933,1.066,12,6.933,12.267,14.133
			c1.867,143.2,2.133,225.333,0,381.866c0,7.2-5.333,13.067-12.267,14.134C256.267,506.4,252.533,506.666,242.133,506.933z"
          />
          <path
            fill="#707070"
            d="M242.133,506.4V94.133c10.4,0.267,13.867,0.533,21.067,1.601c6.933,1.066,12,6.933,12.267,14.133
			c1.867,142.934,2.133,224.8,0,381.066c0,6.934-5.067,13.066-12.267,14.134C256,505.866,252.533,506.133,242.133,506.4z"
          />
          <path
            fill="#727272"
            d="M242.133,505.866V94.4c10.4,0.267,13.867,0.533,20.8,1.601c6.934,1.066,12,6.933,12,14.133
			c1.867,142.4,2.134,224.267,0,380c0,6.934-5.066,12.8-12,14.134C256,505.333,252.533,505.6,242.133,505.866z"
          />
          <path
            fill="#737373"
            d="M242.133,505.333v-410.4c10.4,0.268,13.867,0.534,20.8,1.601c6.934,1.066,12,6.934,12,13.866
			c1.867,142.134,2.134,223.733,0,379.2c0,6.934-5.066,12.8-12,13.866C255.733,504.8,252.533,505.067,242.133,505.333z"
          />
          <path
            fill="#757575"
            d="M242.133,504.8V95.467c10.4,0.267,13.6,0.533,20.8,1.6c6.934,1.066,12,6.934,12,13.866
			c1.867,141.867,2.134,223.2,0,378.134c0,6.934-5.066,12.8-12,13.866C255.733,504.267,252.533,504.533,242.133,504.8z"
          />
          <path
            fill="#767676"
            d="M242.133,504.267V96c10.4,0.267,13.6,0.533,20.533,1.6c6.934,1.066,12,6.934,12,13.867
			c1.867,141.333,2.133,222.666,0,377.333c0,6.933-5.066,12.8-12,13.866C255.733,503.733,252.533,504,242.133,504.267z"
          />
          <path
            fill="#787878"
            d="M242.133,504V96.533c10.4,0.267,13.333,0.533,20.533,1.6c6.934,1.067,12,6.934,12,13.867
			c1.867,141.066,2.133,222.133,0,376.267c0,6.933-5.066,12.8-12,13.866C255.467,503.466,252.533,503.466,242.133,504z"
          />
          <path
            fill="#7A7A7A"
            d="M242.133,503.466V97.067c10.4,0.267,13.333,0.533,20.267,1.6c6.934,1.067,11.733,6.934,12,13.867
			c1.867,140.8,2.133,221.333,0,375.467c0,6.933-5.066,12.8-12,13.866C255.467,502.933,252.267,503.199,242.133,503.466z"
          />
          <path
            fill="#7B7B7B"
            d="M242.133,502.933V97.6c10.4,0.267,13.333,0.533,20.267,1.601c6.934,1.066,11.733,6.933,12,13.866
			c1.867,140.533,2.133,220.8,0,374.666c0,6.934-5.066,12.801-12,13.867C255.2,502.4,252.267,502.666,242.133,502.933z"
          />
          <path
            fill="#7D7D7D"
            d="M242.133,502.4V98.133c10.133,0.267,13.067,0.533,20,1.601c6.934,1.066,11.733,6.933,12,13.866
			c1.867,140,2.133,220.267,0,373.6c0,6.934-5.066,12.801-12,13.867C255.2,501.866,252.267,502.133,242.133,502.4z"
          />
          <path
            fill="#7E7E7E"
            d="M242.133,501.866V98.4c10.133,0.267,13.067,0.533,20,1.601c6.667,1.066,11.733,6.933,11.733,13.6
			c1.6,139.733,2.133,219.733,0,372.8c0,6.934-5.067,12.533-11.733,13.601C255.2,501.333,252.267,501.6,242.133,501.866z"
          />
          <path
            fill="#808080"
            d="M242.133,501.333v-402.4c10.133,0.268,12.8,0.534,19.733,1.601c6.667,1.066,11.733,6.934,11.733,13.6
			c1.6,139.467,2.133,219.2,0,371.733c0,6.934-5.067,12.533-11.733,13.6C254.933,500.8,252.267,501.067,242.133,501.333z"
          />
          <path
            fill="#818181"
            d="M242.133,500.8V99.467c10.133,0.267,12.8,0.533,19.733,1.6c6.667,1.066,11.733,6.667,11.733,13.6
			c1.6,138.934,2.133,218.667,0,370.934c0,6.934-5.067,12.533-11.733,13.6C254.933,500.267,252.267,500.533,242.133,500.8z"
          />
          <path
            fill="#838383"
            d="M242.133,500.267V100c10.133,0.267,12.8,0.533,19.467,1.6c6.667,1.066,11.733,6.667,11.733,13.601
			c1.6,138.666,2.133,218.133,0,369.866c0,6.934-5.067,12.533-11.733,13.6C254.667,499.733,252.267,500,242.133,500.267z"
          />
          <path
            fill="#848484"
            d="M242.133,500V100.533c10.133,0.267,12.533,0.533,19.467,1.6c6.667,1.067,11.733,6.667,11.733,13.601
			c1.6,138.399,2.133,217.6,0,369.066c0,6.933-5.067,12.533-11.733,13.6C254.667,499.466,252.267,499.466,242.133,500z"
          />
          <path
            fill="#868686"
            d="M242.133,499.466V101.067c10.133,0.267,12.533,0.533,19.2,1.6c6.667,1.067,11.466,6.667,11.733,13.601
			c1.6,137.866,2.133,217.066,0,368c0,6.933-5.067,12.533-11.733,13.6C254.667,498.933,252.267,498.933,242.133,499.466z"
          />
          <path
            fill="#888888"
            d="M242.133,498.933V101.6c10.133,0.267,12.267,0.533,19.2,1.601c6.667,1.066,11.466,6.666,11.733,13.6
			c1.6,137.6,2.133,216.533,0,367.2c0,6.933-5.067,12.533-11.733,13.6C254.4,498.4,252,498.666,242.133,498.933z"
          />
          <path
            fill="#898989"
            d="M242.133,498.4V102.133c10.133,0.267,12.267,0.533,18.934,1.601c6.667,1.066,11.466,6.666,11.733,13.6
			c1.6,137.333,2.133,216,0,366.133c0,6.667-5.066,12.534-11.733,13.601C254.4,497.866,252,498.133,242.133,498.4z"
          />
          <path
            fill="#8B8B8B"
            d="M242.133,497.866V102.4c9.867,0.267,12.267,0.533,18.934,1.601c6.667,1.066,11.466,6.666,11.466,13.333
			c1.6,137.066,2.133,215.467,0,365.333c0,6.667-5.066,12.533-11.466,13.334C254.133,497.333,252,497.6,242.133,497.866z"
          />
          <path
            fill="#8C8C8C"
            d="M242.133,497.333v-394.4c9.867,0.268,12,0.534,18.667,1.601c6.667,1.066,11.467,6.667,11.467,13.333
			c1.6,136.533,2.133,214.934,0,364.267c0,6.667-4.8,12.267-11.467,13.333C254.133,496.8,252,497.067,242.133,497.333z"
          />
          <path
            fill="#8E8E8E"
            d="M242.133,496.8V103.467c9.867,0.267,12,0.533,18.667,1.6c6.667,1.066,11.467,6.667,11.467,13.333
			c1.6,136.267,2.133,214.4,0,363.467c0,6.667-4.8,12.267-11.467,13.333C254.133,496.267,252,496.533,242.133,496.8z"
          />
          <path
            fill="#8F8F8F"
            d="M242.133,496.267V104c9.867,0.267,11.733,0.533,18.4,1.6C267.2,106.666,272,112.267,272,118.933
			c1.6,136,2.133,213.867,0,362.4c0,6.667-4.8,12.267-11.467,13.333C253.867,496,252,496,242.133,496.267z"
          />
          <path
            fill="#919191"
            d="M242.133,495.733V104.533c9.867,0.267,11.733,0.533,18.4,1.6C267.2,107.2,272,112.8,272,119.467
			c1.6,135.466,1.867,213.333,0,361.6c0,6.666-4.8,12.267-11.467,13.333C253.867,495.466,252,495.466,242.133,495.733z"
          />
          <path
            fill="#929292"
            d="M242.133,495.466V105.067c9.867,0.267,11.733,0.533,18.4,1.6c6.4,1.067,11.2,6.667,11.467,13.334
			c1.6,135.2,1.867,212.8,0,360.8c0,6.666-4.8,12.267-11.467,13.333C253.6,494.933,252,494.933,242.133,495.466z"
          />
          <path
            fill="#949494"
            d="M242.133,494.933V105.6c9.867,0.267,11.467,0.533,18.133,1.601c6.4,1.066,11.2,6.666,11.467,13.333
			c1.6,134.934,1.867,212.267,0,359.733c0,6.666-4.8,12.267-11.467,13.333C253.6,494.4,252,494.666,242.133,494.933z"
          />
          <path
            fill="#959595"
            d="M242.133,494.4V106.133c9.867,0.267,11.467,0.533,18.133,1.601c6.4,1.066,11.2,6.666,11.467,13.333
			c1.6,134.4,1.867,211.733,0,358.934c0,6.666-4.8,12.267-11.467,13.333C253.6,493.866,252,494.133,242.133,494.4z"
          />
          <path
            fill="#979797"
            d="M242.133,493.866V106.4c9.867,0.267,11.2,0.533,17.867,1.601c6.4,1.066,11.2,6.666,11.2,13.066
			c1.867,134.134,1.867,211.2,0,357.866c0,6.667-4.8,12.267-11.2,13.067C253.333,493.333,251.733,493.6,242.133,493.866z"
          />
        </g>

        <linearGradient
          id="SVGIDC_8_"
          gradientUnits="userSpaceOnUse"
          x1="-378.9844"
          y1="1134.7659"
          x2="-378.9844"
          y2="1128.0657"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0" style="stop-color:#303030" />
          <stop offset="1" style="stop-color:#979797" />
        </linearGradient>
        <path
          fill="url(#SVGIDC_8_)"
          d="M242.133,488.8V111.467c8.533,0.267,12.8,0.533,17.867,1.066v375.199
		C254.933,488.533,250.667,488.533,242.133,488.8z"
        />

        <linearGradient
          id="SVGIDC_9_"
          gradientUnits="userSpaceOnUse"
          x1="-459.335"
          y1="1127.051"
          x2="-298.5352"
          y2="1127.051"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0" style="stop-color:#CBCACA" />
          <stop offset="0.25" style="stop-color:#F7F7F7" />
          <stop offset="0.75" style="stop-color:#F7F7F7" />
          <stop offset="1" style="stop-color:#CBCACA" />
        </linearGradient>
        <path
          fill="url(#SVGIDC_9_)"
          d="M242.133,514.666v-5.333C252.8,509.067,256.8,508.8,264,507.733
		c7.2-1.066,12.267-7.199,12.267-14.133c2.133-158.667,2.133-241.6,0-386.667c0-7.199-5.333-13.066-12.267-14.133
		c-7.2-1.066-11.2-1.333-21.867-1.6v-5.334c10.934,0.267,15.2,0.533,22.667,1.867c9.6,1.6,16.8,9.6,16.8,19.467
		c2.133,145.066,2.133,227.999,0,386.666c0,9.866-7.2,17.866-16.8,19.467C257.333,514.133,253.067,514.4,242.133,514.666z"
        />
        <path
          fill="#676767"
          d="M258.933,155.2h-14.4c-0.8,0-1.6,0-2.4-0.268v-44c0.533-0.267,1.6-0.267,2.4-0.267h14.4
		c6.934,0,12.534,5.601,12.534,12.534v19.466C271.467,149.6,265.867,155.2,258.933,155.2z"
        />
        <path
          fill="#1A1A1A"
          d="M257.067,152.267H244c-0.8,0-1.333,0-2.133-0.267v-38.4c0.8-0.267,1.333-0.267,2.133-0.267h13.067
		c6.4,0,11.466,5.066,11.466,11.467v16C268.8,147.2,263.467,152.267,257.067,152.267z"
        />
        <g>
          <ellipse cx="256.267" cy="132.8" rx="10.133" ry="11.467" />
          <g>
            <image
              overflow="visible"
              enable-background="new    "
              width="10"
              height="10"
              xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsSAAALEgHS3X78AAAA
GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAM9JREFUeNp8TzEORFAQnc+eQEdC
oxFUv3cCV9A4gNZplHqVViORuACVVqPTqGRkZvezsrKv+Jn5782beQBfSJIELctCqqMowjiOUXGa
+iRB0zTn0L7vEAQBFEXB4hc9YRgy2batUMKu64Su61jX9bVSOcIDiEvTFDXTNFkwz7N4Ek7TBL7v
v2+k5h+WZQF2kVLitm0wjuPNlc5xXfdKnWUZN47j/NxpGAaHPB3yPMeyLLlGRBAfyrZt6Pte3FZ5
nkcJYRgGWNcVqqo6+UOAAQA9IU/xJLQzdAAAAABJRU5ErkJggg=="
              transform="matrix(2.6667 0 0 2.6667 242.667 120.0002)"
            ></image>
          </g>
        </g>
        <path
          fill="#676767"
          d="M258.933,489.067h-14.4c-0.8,0-1.6,0-2.4-0.267v-44c0.533-0.267,1.6-0.267,2.4-0.267h14.4
		c6.934,0,12.534,5.6,12.534,12.533v19.467C271.467,483.466,265.867,489.067,258.933,489.067z"
        />
        <path
          fill="#1A1A1A"
          d="M257.067,486.4H244c-0.8,0-1.333,0-2.133-0.267v-38.667c0.8-0.267,1.333-0.267,2.133-0.267h13.067
		c6.4,0,11.466,5.067,11.466,11.467v16C268.8,481.067,263.467,486.4,257.067,486.4z"
        />
        <g>
          <ellipse cx="256.267" cy="466.933" rx="10.133" ry="11.467" />
          <g>
            <image
              overflow="visible"
              enable-background="new    "
              width="10"
              height="10"
              xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsSAAALEgHS3X78AAAA
GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMpJREFUeNp8jjEORFAQhv/3HEAn
QSd6jQKJE4jSqVS0WoU4gAu4glajoBEKNbPLhryX7O4kk0xmvvnycwhVVRWFYXh1mqYk3tg9uK5L
27ZB0zTs+w5FUTCOI3zfR1mWH64oistiGIZkOXeO49BjvIG3gYmg+MhM0yTLstC2rQSJ1jiOwY/j
wL/q+x7zPINP08SWZYFt2/QL7roO/ByiKPoK3BmbpmFPriAIaF1XqKqKYRgeOEkSZFkm58/znDzP
I13Xqa5rKcpLgAEAxN1Tv4fZbVAAAAAASUVORK5CYII="
              transform="matrix(2.6667 0 0 2.6667 242.667 453.3342)"
            ></image>
          </g>
        </g>

        <linearGradient
          id="SVGIDC_10_"
          gradientUnits="userSpaceOnUse"
          x1="-409.9087"
          y1="1129.301"
          x2="-408.1541"
          y2="1129.301"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0" style="stop-color:#303030" />
          <stop offset="1" style="stop-color:#979797" />
        </linearGradient>
        <path
          fill="url(#SVGIDC_10_)"
          d="M242.133,222.4v-4.8H268.8c1.333,0,2.4,1.066,2.4,2.4l0,0c0,1.333-1.067,2.399-2.4,2.399H242.133z"
        />

        <linearGradient
          id="SVGIDC_11_"
          gradientUnits="userSpaceOnUse"
          x1="-349.7534"
          y1="1129.301"
          x2="-347.9989"
          y2="1129.301"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0" style="stop-color:#303030" />
          <stop offset="1" style="stop-color:#979797" />
        </linearGradient>
        <path
          fill="url(#SVGIDC_11_)"
          d="M242.133,382.666v-4.8H268.8c1.333,0,2.4,1.066,2.4,2.4l0,0c0,1.333-1.067,2.399-2.4,2.399H242.133
		L242.133,382.666z"
        />
      </g>
      <g id="Logo_3_">
        <linearGradient
          id="SVGIDC_12_"
          gradientUnits="userSpaceOnUse"
          x1="-378.6343"
          y1="1045.6917"
          x2="-378.6343"
          y2="1037.0743"
          gradientTransform="matrix(1.197253e-010 2.6667 -2.6667 1.197253e-010 3268.1367 1310.76)"
        >
          <stop offset="0" style="stop-color:#333333" />
          <stop offset="1" style="stop-color:#FFFFFF" />
        </linearGradient>
        <circle fill="url(#SVGIDC_12_)" cx="491.2" cy="301.067" r="11.467" />

        <linearGradient
          id="SVGIDC_13_"
          gradientUnits="userSpaceOnUse"
          x1="879.0723"
          y1="101.4563"
          x2="879.0723"
          y2="94.1972"
          gradientTransform="matrix(-1.197253e-010 -2.6667 2.6667 -1.197253e-010 230.248 2645.2603)"
        >
          <stop offset="0" style="stop-color:#808080" />
          <stop offset="1" style="stop-color:#FFFFFF" />
        </linearGradient>
        <circle fill="url(#SVGIDC_13_)" cx="491.2" cy="301.067" r="9.6" />
      </g>
      <path
        fill="#B9BABA"
        d="M408.8,390.4v-176c0-2.399,1.866-4.267,4.267-4.267h30.4c2.4,0,4.267,1.867,4.267,4.267v175.733
	c0,2.4-1.866,4.267-4.267,4.267h-30.133C410.934,394.666,408.8,392.8,408.8,390.4z"
      />
      <path
        fill="#A71916"
        d="M436,135.733V21.067c24.533,2.399,42.934,9.333,57.334,28c-1.334,24.8-2.934,42.666-8.533,66.666
	c-2.667,11.2-9.601,21.401-20.268,25.934l-12.866,5.474C443.134,150.874,436,144.8,436,135.733z"
      />
      <path
        fill="#E31715"
        d="M492.8,61.693c-3.466-0.8-6.933-1.601-10.133-2.134l-23.733-2.133c-6.667,0.267-14.134,1.066-22.667,2.399
	v43.2v29.066c21.067-6.133,33.867-11.732,51.467-24.533c1.867-9.866,3.2-18.666,4-28l-1.6,0.801
	C490.934,74.492,492.533,66.492,492.8,61.693z"
      />
      <path
        fill="#2A0D0E"
        d="M451.867,150.228l12-5.066c10.667-4.533,18.667-13.867,21.334-25.067c5.6-24,7.065-46.228,8.133-71.027
	c-1.067-1.601-1.431-1.737-2.497-3.07c0,0-2.703,51.165-8.836,73.031c-2.667,10.134-9.867,18.934-19.467,22.934l-12,5.066
	c-3.2,1.334-5.867,1.334-8,0c-2.134-1.333-3.2-4-3.2-7.2l1.998-118.151c-1.066,0-4.131-0.608-5.198-0.608v118.759
	C436.4,149.161,443.334,153.961,451.867,150.228z"
      />
      <g id="Lights"></g>
      <g id="B-Light_2_">
        <path
          fill="#A71916"
          d="M436.199,467.028v114.667c24.533-2.133,42.934-9.333,57.334-28c-1.334-24.8-2.934-42.667-8.533-66.667
		c-2.666-11.199-10.666-20.533-21.334-25.066l-12-5.066C443.133,453.161,436.199,457.695,436.199,467.028z"
        />
        <path
          fill="#E31715"
          d="M482.6,547.294c3.201-0.533,6.668-1.333,10.135-2.133c-0.268-5.333-1.867-12.8-2.668-18.4l1.6,0.533
		c-0.799-9.333-2.133-18.133-4-28c-17.6-12.533-30.398-18.133-51.467-24.267v28.801v43.199c8.533,1.334,16,2.134,22.668,2.4"
        />
        <path
          fill="#2A0D0E"
          d="M451.666,456.628l12,5.066c10.668,4.533,18.668,13.866,21.334,25.066c5.6,24,7.467,41.867,8.533,66.667
		c-1.066,1.6-1.867,2.4-2.934,3.733c0,0-2.666-47.467-8.799-69.333c-2.668-10.134-9.867-18.934-19.467-22.934l-12-5.066
		c-3.201-1.334-5.867-1.334-8,0c-2.135,1.333-3.201,4-3.201,7.199v114.4c-1.066,0-2.133,0.267-3.199,0.267V467.028
		C436.199,457.695,443.133,453.161,451.666,456.628z"
        />
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    bumper: Number,
    boot: Number
  },

  data() {
    return {
      rear: {
        bumper: 0,
        boot: 0
      }
    };
  },

  computed: {
    bumperClass() {
      return this.getSeverityColour(this.rear.bumper);
    },

    bootClass() {
      return this.getSeverityColour(this.rear.boot);
    }
  },

  methods: {
    changeSeverity(section) {
      if (this.rear[section] == 3) {
        this.rear[section] = 0;
      } else {
        this.rear[section] = this.rear[section] + 1;
      }

      this.$emit('updated', this.rear);
    },

    getSeverityColour(severity, defaultColour = '#D9D9D9', opacity = null) {
      const colour = this.getColour(severity, defaultColour);

      if (opacity) {
        return {
          opacity,
          ...colour
        };
      }

      return colour;
    },

    getColour(severity, defaultColour = '#D9D9D9') {
      switch (severity) {
        case 1:
          return {
            fill: '#FFCA28'
          };

        case 2:
          return {
            fill: '#f0ad4e'
          };

        case 3:
          return {
            fill: '#d9534f'
          };

        default:
          return typeof defaultColour === 'string'
            ? {
                fill: defaultColour
              }
            : defaultColour;
      }
    }
  },

  watch: {
    bumper: {
      handler(value) {
        if (value) {
          this.rear.bumper = value;
        }
      },
      immediate: true,
      deep: true
    },

    boot: {
      handler(value) {
        if (value) {
          this.rear.boot = value;
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
